<template>
  <div class="info">
    <p class="people">
      <!-- <i class="fas fa-user ico mr-0"></i> -->
      <img src="@/assets/icons/ico-user.svg" alt="" />
      <span>
        <slot name="info-people"></slot>
      </span>
    </p>
    <p class="sqrmeter">
      <!-- <i class="fas fa-crop-alt ico mr-0"></i> -->
      <img src="@/assets/icons/ico-crop.svg" alt="" />
      <slot name="info-sqr"></slot>
    </p>
    <p class="beds">
      <!-- <i class="fas fa-bed ico mr-0"></i> -->
      <img src="@/assets/icons/ico-bed.svg" alt="" />
      <span>
        <slot name="info-bed"></slot>
      </span>
    </p>
    <p class="couch">
      <!-- <i class="fas fa-couch ico mr-0"></i> -->
      <img src="@/assets/icons/ico-couch.svg" alt="" />
      <span>
        <slot name="info-couch"></slot>
      </span>
    </p>
    <p class="apart">
      <!-- <i class="fas fa-building ico mr-0"></i> -->
      <img src="@/assets/icons/ico-building.svg" alt="" />
      <slot name="info-apart"></slot>
    </p>
  </div>
</template>

<script>
export default {
  name: 'RoomInfo',
};
</script>

<style scoped lang="scss">
.info {
  color: hsl(var(--clr-primary-100));
  margin-bottom: 24px;

  display: grid;
  justify-items: start;
  grid-template-columns: 1fr 2fr;
  grid-template-rows: repeat(3, 1fr);
  row-gap: 10px;
  column-gap: 16px;

  // .ico {
  //   color: var(--secondary);
  // }
  img {
    margin-right: 5px;
  }
}

.people {
  // justify-self: center;
  grid-column: 1/2;
  grid-row: 1/2;

  font-size: 16px;
  font-weight: 500;
}

.sqrmeter {
  // justify-self: center;
  grid-column: 1/2;
  grid-row: 2/3;
}

.beds {
  grid-column: 2/3;
  grid-row: 1/2;
}

.couch {
  grid-column: 2/3;
  grid-row: 2/3;
}

.apart {
  // justify-self: center;
  grid-column: 1/3;
  grid-row: 3/4;
}

@media (max-width: 900px) {
  .people {
    font-size: 16px;
  }
  .beds {
    font-size: 16px;
  }
  .couch {
    font-size: 16px;
  }
  .sqrmeter {
    font-size: 16px;
  }
}
</style>
